<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card class="pb-5">
        <v-card-title class="text-uppercase">
          <h5>Suggest Reviewer</h5>
        </v-card-title>
        <v-card-text>
          <v-form
            class="mt-3"
            v-model="valid"
            @submit.prevent="confirmSuggestion"
          >
            <v-row>
              <v-col cols="5">
                <v-select
                  :items="titles"
                  outlined
                  label="Title *"
                  :rules="rules.required"
                  v-model="reviewer.title"
                ></v-select>
              </v-col>
              <v-col cols="7">
                <v-text-field
                  outlined
                  label="First Name *"
                  :rules="rules.required"
                  v-model="reviewer.firstName"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-text-field
              outlined
              label="Last Name *"
              :rules="rules.required"
              v-model="reviewer.lastName"
            ></v-text-field>

            <v-combobox
              v-model="reviewer.institution"
              :items="institutions"
              item-text="name"
              item-value="name"
              label="Institution name *"
              outlined
              :return-object="false"
              :rules="rules.required"
            ></v-combobox>

            <v-text-field
              outlined
              label="Department / College *"
              :rules="rules.required"
              v-model="reviewer.department"
            ></v-text-field>

            <v-text-field
              outlined
              label="Specialization (optional)"
              v-model="reviewer.specialization"
            ></v-text-field>

            <v-divider class="mt-3 mb-10"></v-divider>

            <v-text-field
              outlined
              label="Email *"
              :rules="rules.required"
              v-model="reviewer.email"
            ></v-text-field>

            <v-text-field
              outlined
              label="Phone number (optional)"
              v-model="reviewer.phone"
              hide-details
            ></v-text-field>

            <!-- <div class="ml-8">
              <p class="mb-7">* mark required fields.</p>
              <v-btn
                color="green"
                type="submit"
                class="white--text mr-2"
                :disabled="!valid || registering || reviewer.password != confirm"
                :loading="registering"
              >
                Create Profile
              </v-btn>
              <v-btn color="green" type="submit" text to="/login">
                Login Instead
              </v-btn>
            </div> -->
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog"> Cancel </v-btn>
          <v-btn
            color="green lighten-1"
            text
            @click="confirmSuggestion"
            :disabled="!valid"
          >
            Submit suggestion
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { required } from "../../../tools/rules";
import Institutions from "../../../data/world_universities_and_domains-min.json";

export default {
  props: ["open"],

  data: () => ({
    dialog: false,
    reviewer: {
      title: null,
      firstName: null,
      lastName: null,
      institution: null,
      department: null,
      specialization: null,
      email: null,
      phone: null,
    },

    valid: false,
    rules: {
      required,
    },

    titles: ["Dr.", "Prof.", "Mr.", "Miss."],
    institutions: Institutions,
  }),

  watch: {
    open(value) {
      this.dialog = value;
    },
  },

  methods: {
    closeDialog() {
      this.$emit("cancel");
      this.dialog = false;
    },
    confirmSuggestion() {
      this.$emit("suggest", this.reviewer);
      this.dialog = false;
    },
  },
};
</script>